import { render, staticRenderFns } from "./DeleteCoupon.vue?vue&type=template&id=4b3efb88"
import script from "./DeleteCoupon.vue?vue&type=script&lang=js"
export * from "./DeleteCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports